import React, { useState, Fragment } from "react";
import styled from "styled-components";
import { fontSize } from "../lib/fonts";
import { Tooltip } from "./ui/Tooltip";
import {
  TableRowTitle,
  TablePriceType,
  TablePriceRow,
  HiddenTableRow,
  checkedIcon,
  uncheckedIcon,
  HeaderTh,
} from "./TablePrice";
import { Title } from "./ui/Title";

const CustomTable = styled.table`
  width: 100%;
  margin: 30px 0;
  border-collapse: collapse;
  box-shadow: 0px 5px 30px 0px rgba(27, 22, 51, 0.05);
  border-radius: 10px;
  ${fontSize("12px")};

  td:last-child {
    padding-right: 20px;
    text-align: right;
  }

  td:first-child {
    padding-left: 20px;
    text-align: left;
  }
`;

const TooltipBox = styled.div`
  display: flex;
  align-items: center;
`;

export const TablePriceMobile = ({
  mobileType,
  mobileRows,
}: {
  mobileType: TablePriceType;
  mobileRows: TablePriceRow[];
}) => {
  const [isHidden] = useState(false);

  return (
    <>
      <CustomTable>
        <thead>
          <tr>
            <HeaderTh colSpan={2}>
              <Title htmlLevel={3} theme="titleTableStyle">
                {mobileType.title}
              </Title>
              <div className="numberOfFiles">
                {mobileType.dossier} dossier/mois
              </div>
              <div>
                <span className="price">
                  {mobileType.prixDossier}
                  <span className="euro">€</span>
                </span>
                /mois
              </div>
              {/* <div className="priceMonths">+ {mobileType.prixMois}€ /mois</div> */}
            </HeaderTh>
          </tr>
        </thead>

        <tbody>
          {mobileRows.map((item, i) => (
            <Fragment key={i}>
              <tr>
                <TableRowTitle className="categorieTitle" colSpan={2}>
                  {item.title}
                </TableRowTitle>
              </tr>

              {item.list.map((element, j) => (
                <tr key={j}>
                  <td>
                    <HiddenTableRow
                      forMobile={true}
                      visible={element.show || isHidden}
                    >
                      <TooltipBox>
                        <div>{element.label}</div>
                        {element.icon === true && (
                          <div style={{ marginLeft: 5 }}>
                            <Tooltip tooltipMessage={element.tooltipText} />
                          </div>
                        )}
                      </TooltipBox>
                    </HiddenTableRow>
                  </td>
                  <td>
                    <HiddenTableRow
                      forMobile={true}
                      visible={element.show || isHidden}
                    >
                      {element.values[mobileType.key] === true
                        ? checkedIcon
                        : element.values[mobileType.key] === false
                        ? uncheckedIcon
                        : element.values[mobileType.key]}
                    </HiddenTableRow>
                  </td>
                </tr>
              ))}
            </Fragment>
          ))}
        </tbody>
      </CustomTable>
    </>
  );
};
